export const ROUTE_URLS = {
  LANDING: 'home',
  TOP_UP: 'top-up',
  SUPPORT: 'support',
  SWAP_PLAN: 'swap-plan',
  PLANS: 'plans',
  TERMS_CONDITIONS: 'terms-and-conditions',
  LEGAL_PRIVACY: 'legal-privacy',
  CONFIRM_TOPUP: 'confirm-topup',
  CHECK_COMPATIBILITY: 'check-compatibility',
  VOUCHER: 'redeem-voucher',
  PORT: 'switch'
}
export const SUPPORT_URLS = {
  BASE: 'support',
  SERVICE_UPDATE: 'service-update',
  GETTING_STARTED: 'getting-started',
  PLANS: 'plans',
  DATA_SETTINGS: 'data-settings',
  NATIONAL_COVERAGE: 'national-coverage',
  NUMBER_PORTABILITY: 'number-portability',
  MOBILE_DATA: 'mobile-data',
  ACTIVATION_ACCOUNT: 'activation-account-support',
  PHONES_SIM: 'phones-and-sim',
  LOST_STOLEN: 'lost-stolen-damaged',
  EMERGENCY: 'understanding-911',
  CUSTOMER_SERVICE: 'customer-service-returns',
  CRTC: 'crtc-wireless-code',
  ALERT_READY: 'alert-ready'
}
export const ACTIVATION_URLS = {
  BASE: 'activation',
  CHOOSE_PATH: 'choose-path',
  NO_SIM_PATH: 'no-sim-path',
  ACTIVATE_NUMBER: 'activate-number',
  ACTIVATION_SUMMARY: 'summary',
  PARAMS: {
    IMEI: 'imei',
    PLAN_ID: 'planId',
    MDN:'mdn'
  }
}

export const ACCOUNT_URLS = {
  BASE: 'account',
  SUMMARY: 'summary',
  ORDERS: 'orders',
  SETTINGS: 'settings',
  PENDING_ACTIVATIONS: 'pending-activations',
  BILLING: 'billing-information',
  PARAMS: {
    ADD_CARDS: 'addCards',
    MANAGE_CARDS: 'manageCards'
  }
}
export const AUTH_URLS = {
  BASE: 'auth',
  SIGNUP: 'signup',
  LOGIN: 'login',
  LEGACY_LOGIN: 'legacy-login',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  VERIFY_EMAIL: 'verify-email',
  WELCOME: 'welcome',
  PARAMS: {
    EMAIL: 'email',
    OOB_CODE: 'oobCode',
    EXPIRED: 'expired',
    NEXT_PAGE: 'nextPage'
  }
}
